import React, { useState } from 'react';
import Select from 'react-select';
import Tooltip from '@/components/common/Tooltip';

interface LessonOverviewDisplayLocationFieldProps {
  values: any;
  setFormValue: (field: string, value: string | null) => void;
}

const LessonOverviewDisplayLocationField = ({ values, setFormValue }: LessonOverviewDisplayLocationFieldProps) => {
  const [isChecked, setIsChecked] = useState(!!values.display_location_in_lesson_overview);
  const [displayedLocation, setDisplayedLocation] = useState(values.display_location_in_lesson_overview);

  const handleCheckboxChange = () => {
    if (isChecked) {
      setDisplayedLocation(null);
      setFormValue('display_location_in_lesson_overview', null);
    }

    setIsChecked(!isChecked);
  };

  const locationOptions = [
    { label: 'Introduce the Lesson', value: 'introduce_the_lesson' },
    { label: 'Lesson Options', value: 'lesson_options' },
    { label: 'Put It All Together', value: 'put_it_all_together' },
  ];

  const handleSelectChange = (option) => {
    const value = option ? option.value : null;
    setDisplayedLocation(value);
    setFormValue('display_location_in_lesson_overview', value);
  };

  return (
    <div className="tw-flex-col tw-w-full">
      <div className="tw-flex tw-items-center">
        <label className="tw-mr-2 tw-font-bold tw-inline-flex tw-items-center" htmlFor="display_in_lesson_overview_toggle_field">
          <span>
            Display Card on Lesson Overview Page
            <Tooltip content="Enabling this setting will show a card on the Lesson Overview page for this Slide Group." size="medium" theme="white">
              <span>
                <i aria-hidden className="fa fa-question-circle" />
                <span className="sr-only">Enabling this setting will show a card on the Lesson Overview page for this Slide Group.</span>
              </span>
            </Tooltip>
          </span>
          <input
            checked={isChecked}
            className="tw-ml-2"
            id="display_in_lesson_overview_toggle_field"
            type="checkbox"
            onChange={handleCheckboxChange}
          />
        </label>
        {isChecked && (
          <div className="tw-flex tw-items-center tw-ml-8">
            <label className="tw-mr-2 tw-font-bold" htmlFor="display_location_select">
              Card Location
            </label>
            <div className="tw-w-48">
              <Select
                isClearable={false}
                options={locationOptions}
                placeholder="Location..."
                value={locationOptions.find(opt => opt.value === displayedLocation) || null}
                onChange={handleSelectChange}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LessonOverviewDisplayLocationField;
